import React from 'react'

export interface MobileStatusChip {
  key: string
  label: string
  count: number
  active?: boolean
  /** Tailwind classes for the active chip (default blue) */
  activeClassName?: string
}

interface MobileStatusChipsProps {
  chips: MobileStatusChip[]
  onSelect: (key: string) => void
  className?: string
}

/**
 * Horizontally scrollable status filter chips for phone / PWA list pages.
 */
export function MobileStatusChips({ chips, onSelect, className = '' }: MobileStatusChipsProps) {
  return (
    <div className={`-mx-3 px-3 overflow-x-auto scrollbar-none ${className}`}>
      <div className="flex gap-2 pb-0.5 min-w-max">
        {chips.map((chip) => {
          const active = !!chip.active
          const activeCls =
            chip.activeClassName || 'bg-blue-600 text-white border-blue-600 shadow-sm shadow-blue-600/25'
          return (
            <button
              key={chip.key}
              type="button"
              onClick={() => onSelect(chip.key)}
              className={`native-chip ${
                active
                  ? activeCls
                  : 'bg-white text-gray-700 border-gray-200 active:bg-gray-50'
              }`}
            >
              <span>{chip.label}</span>
              <span
                className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-xs font-semibold ${
                  active ? 'bg-white/20 text-inherit' : 'bg-gray-100 text-gray-600'
                }`}
              >
                {chip.count}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
